export * from './academic/attendance/attendance-status-settings.interface';
export * from './academic/attendance/attendance-status.interface';
export * from './academic/attendance/attendance.interface';
export * from './academic/attendance/individuals-status.interface';
export * from './academic/learning-path/curriculum.interface';
export * from './academic/learning-path/curriculum-level.interface';
export * from './academic/learning-path/objective-level.interface';
export * from './academic/learning-path/curriculum-item.interface';
export * from './academic/learning-path/curriculum-item-resource.interface';
export * from './academic/learning-path/curriculum-item-statistic.interface';
export * from './academic/learning-path/curriculum-statistic.interface';
export * from './academic/learning-path/instructor.interface';
export * from './academic/learning-path/subject.interface';
export * from './academic/learning-path/sections-subjects.interface';
export * from './academic/learning-path/class.interface';
export * from './academic/learning-path/section.interface';
export * from './academic/learning-path/objective.interface';
export * from './academic/learning-path/resource.interface';
export * from './academic/learning-path/syllabus-level.interface';
export * from './academic/learning-path/syllabus-level-resource.interface';
export * from './academic/learning-path/daily-plan-settings.interface';
export * from './academic/learning-path/file.interface';
export * from './academic/learning-path/assessment-category.interface';
export * from './academic/learning-path/assessment-subcategory.interface';
export * from './academic/learning-path/post.interface';
export * from './academic/learning-path/like.interface';
export * from './academic/learning-path/view.interface';
export * from './academic/learning-path/comment.interface';
export * from './academic/learning-path/link.interface';
export * from './academic/learning-path/assignment.interface';
export * from './academic/learning-path/assignment-attachment.interface';
export * from './academic/learning-path/assignment-link.interface';
export * from './academic/learning-path/assignment-statistic.interface';
export * from './academic/learning-path/question.interface';
export * from './academic/learning-path/question-option.interface';
export * from './academic/learning-path/question-option-possible.interface';
export * from './academic/learning-path/assignment-question-score.interface';
export * from './academic/learning-path/assignment-question-option-score.interface';
export * from './academic/learning-path/question-option-possible-score.interface';
export * from './academic/learning-path/assignment-answer.interface';
export * from './academic/learning-path/assignment-question-answer.interface';
export * from './academic/learning-path/assignment-results.interface';
export * from './academic/learning-path/assignment-student.interface';
export * from './academic/learning-path/scope-and-sequence.interface';
export * from './academic/learning-path/dashboard.interface';

export * from './academic/plans/section-subject-plans.interface';
export * from './academic/plans/sections-plans.interface';
export * from './academic/plans/semester-plan.interface';
export * from './academic/plans/semester-plan-week.interface';
export * from './academic/plans/weekly-plan.interface';
export * from './academic/plans/weekly-plan-period.interface';
export * from './academic/plans/weekly-plan-period-resource.interface';
export * from './academic/plans/daily-plan.interface';
export * from './academic/plans/daily-plan-action.interface';
export * from './academic/plans/plans-subjects-settings.interface';

export * from './academic/subjects-management/gp-classification.interface';
export * from './academic/subjects-management/education-mean.interface';
export * from './academic/subjects-management/teaching-strategy.interface';
export * from './academic/subjects-management/evaluation-strategy.interface';
export * from './academic/subjects-management/evaluation-tool.interface';
export * from './academic/subjects-management/learning-phase.interface';
export * from './academic/subjects-management/learning-action-type.interface';
export * from './academic/subjects-management/learning-classification.interface';
export * from './academic/subjects-management/global-subject.interface';

export * from './academic/time-table/schedule-set.model';

export * from './system-setting/academic-year-manage/academic-years.interface';
export * from './system-setting/academic-year-manage/periods.interface';
export * from './system-setting/academic-year-manage/academic-semesters.interface';

export * from '../_enums/schedule-type.enum';
export * from '../_enums/assessment-scaled-status.enum';
export * from '../_enums/subject-type.enum';
export * from '../_enums/curriculum-item-resource-type.enum';

export * from './common/row-select.interface';
export * from './common/table-select.interface';
export * from './common/user.interface';
export * from './common/modal-messages.interface';
export * from './common/notification.interface';
export * from './common/tabs.interface';
export * from './communications/event/calender-event';
export * from './common/notification.interface';
export * from './common/user-type.interface';
export * from './common/grid-paginator';
export * from './common/school-bmi-statistics';
export * from './common/user-disease-medical-statistics';
export * from './common/lookup-items.inteface';
export * from './common/url-meta-date.interface';
export * from './common/animated-boxes.interface';

export * from './communications/event/reminder-setting';
export * from './communications/alert-type.interface';
export * from './communications/sms-type.interface';
export * from './communications/email-message.interface';
export * from './communications/gallery.interface';
export * from './communications/social-learning.interface';

export * from './users/user-data';
export * from './users/academic-detail';
export * from './users/personal-information';
export * from './users/additional-details';
export * from './users/skills-social-details';
export * from './users/medical-logs';
export * from './users/medical-records';
export * from './users/custom-alerts';
export * from './users/user-attendance';
export * from './users/general-user-model';
export * from './users/user-statistics';
export * from './users/attachments-management.interface';
export * from './system-setting/academics-manage/stage-selection-class';
export * from './academic/acadmeic-filter';
export * from './common/paged-result.interface';

export * from './academic/grading-assessment/audit-analysis';
export * from './academic/grading-assessment/overall-scale-setting';
export * from './academic/grading-assessment/assessment-category';
export * from './academic/grading-assessment/auditor';
export * from './academic/grading-assessment/student-assessment-scale';
export * from './academic/grading-assessment/assessment-scale';
export * from './academic/grading-assessment/student-specific-scale';
export * from './academic/grading-assessment/scaled-assessment';
export * from './academic/grading-assessment/assessment-scale-range';
export * from './users/user-relation';
export * from './users/user-health-record';
export * from './users/staff-member-class';

export * from './academic/grading-assessment/grade-setup';
export * from './academic/grading-assessment/honour-setting-types';
export * from './academic/attendance/attendance-status-backend.interface';
export * from './academic/attendance/attendance-session-classes.interface';
export * from './academic/attendance/attendance-search.interface';
export * from './academic/attendance/attendance-register-student.interface';
export * from './academic/attendance/attendance-session.interface';
export * from './academic/attendance/attendance-today-wise-classes.interface';
export * from './academic/attendance/attendance-view-wise.interface';
export * from './academic/attendance/attendance-submission-analytics.interface';
export * from './academic/attendance/today-attendance-search.interface';
export * from './academic/attendance/today-attendance-section-summary.interface';
export * from './users/user-login';
export * from './users/current-user-logged-in';
export * from './users/identity-details';
export * from './users/system-user-type';
export * from './users/user-role-type';
export * from './users/role';
export * from './users/module-group-role';
export * from './users/school-user-type-detail';
export * from './common/school-basic-information';
export * from './academic/attendance/attendance-statistics-reports.interface';
export * from './academic/study-table/works-room.interface';
export * from './academic/grading-assessment/auditor-info';
export * from './academic/grading-assessment/auditor-details';
export * from './academic/study-table/schedule-category.interface';
export * from './academic/study-table/schedule-category-link.interface';
export * from './academic/study-table/schedule-category-auto.inteface';
export * from './academic/study-table/view-schedule.interface';
export * from './academic/study-table/tracker.interface';
export * from './academic/study-table/sectionSummaryAssessment';
export * from './academic/study-table/sectionSummarySubjects';
export * from './academic/study-table/schedule-generate.interface';
export * from './academic/study-table/submission-analytics.interface';
export * from './academic/evaluations/evaluations.interface';
export * from './school/school';
export * from './school/school-educational-details';
export * from './common/menu-list.interface';
export * from './common/disease-medical';
export * from './common/add-notice';
export * from './common/add-circulars';
export * from './common/view-notice';
export * from './common/view-circular';
export * from './common/new';
export * from './common/view-published-notice';
export * from './common/view-published-circular';
export * from './common/key-value-pair.interface';
export * from './common/students-lookup.interface';
export * from './academic/subjects-allocation.interface';
export * from './academic/study-table/assign-teachers.interface';
export * from './academic/notes/NoteModels';
export * from '../_enums/assessment-scale-enum';
export * from './communications/notices.interface';
// Start Students Portal
export * from './students/menu.interface';
export * from './common/navigator.interface';
